//* Components
import Image from 'components/common/Image';
import Video from 'components/common/Video';

//* Style
import FullImageVideoStyle from './style';

const FullImageVideo = ({ file, alt }) => {
	return file ? (
		<FullImageVideoStyle>
			{file.type === 'image' ? (
				<Image
					objectFit={'cover'}
					src={file.url}
					className={'full-width-image-video'}
					alt={alt}
				/>
			) : (
				<Video
					className={'full-width-image-video'}
					src={file.url}
					poster={file.poster}
					autoplay={false}
					loop={false}
					muted={false}
					controls={false}
				/>
			)}
		</FullImageVideoStyle>
	) : null;
};

export default FullImageVideo;
